/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TierChangeNotificationActionData } from './TierChangeNotificationActionData';
import {
    TierChangeNotificationActionDataFromJSON,
    TierChangeNotificationActionDataFromJSONTyped,
    TierChangeNotificationActionDataToJSON,
} from './TierChangeNotificationActionData';

/**
 * 
 * @export
 * @interface TierChangeNotificationAction
 */
export interface TierChangeNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof TierChangeNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof TierChangeNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof TierChangeNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {TierChangeNotificationActionData}
     * @memberof TierChangeNotificationAction
     */
    data: TierChangeNotificationActionData;
}

/**
 * Check if a given object implements the TierChangeNotificationAction interface.
 */
export function instanceOfTierChangeNotificationAction(value: object): value is TierChangeNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TierChangeNotificationActionFromJSON(json: any): TierChangeNotificationAction {
    return TierChangeNotificationActionFromJSONTyped(json, false);
}

export function TierChangeNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TierChangeNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': TierChangeNotificationActionDataFromJSON(json['data']),
    };
}

export function TierChangeNotificationActionToJSON(value?: TierChangeNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': TierChangeNotificationActionDataToJSON(value.data),
    };
}

